module.exports = __webpack_public_path__ + "static/img/bg_draw.7b5c19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_draw.png
// module id = UMOJ
// module chunks = 1